import { themeAtom } from "../../shared/atoms";
import Avatar from "../../shared/components/Avatar";
import { formatDateToShortString, PnlContext } from "../utils/UtilFunctions";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

const TopPnlClarifications: React.FC = () => {
  const theme = useAtomValue(themeAtom);

  const voyagePnlData = useAtomValue(PnlContext);

  if (!voyagePnlData) return null; // or a loading state, fallback UI, etc.

  return (
    <>
      <div>
        <div className={twMerge("text-[11px]", theme.uwhcAssistant.text)}>PnL Clarifications</div>
        <h1 className={twMerge("mt-2 text-[24px] font-semibold", theme.home.tailwind.textDefault)}>
          End of voyage PnL Clarifications
        </h1>
        <p className={twMerge("max-w-[736px] text-[14px]", theme.uwhcAssistant.text)}>
          Please complete the form, detailing only the core reasons for non-offset variances from the estimate. This
          will help us capture insights to improve our commercial and operational performance.
        </p>
      </div>

      <div
        className={twMerge(
          "flex w-full flex-row items-center justify-between rounded-lg border px-10 py-6",
          theme.uwhcAssistant.border,
          theme.home.tailwind.panelBackground,
          theme.home.tailwind.textDefault,
        )}
      >
        <div className="flex flex-row gap-2 text-left">
          <div className="flex flex-col gap-1">
            <div className={twMerge("text-[11px]", theme.vesselDetails.fields)}>Commencing</div>
            <div className="text-[14px]">{formatDateToShortString(voyagePnlData.voyageParams.commencingDate)}</div>
          </div>
          <div className="flex items-end">
            <span className={twMerge("text-sm", theme.vesselDetails.fields)}>→</span>
          </div>

          <div className="flex flex-col gap-1">
            <div className={twMerge("text-[11px]", theme.vesselDetails.fields)}>Completing</div>
            <div className="text-[14px]">{formatDateToShortString(voyagePnlData.voyageParams.completingDate)}</div>
          </div>
        </div>

        <div className="flex flex-col gap-1">
          <div className={twMerge("text-[11px]", theme.vesselDetails.fields)}>Snapshot</div>
          <div className="text-[14px]">{formatDateToShortString(voyagePnlData.voyageParams.snapshotDate)}</div>
        </div>

        <div className="flex flex-col gap-1">
          <div className={twMerge("text-[11px]", theme.vesselDetails.fields)}>Vessel</div>
          <div className="text-[14px]">{voyagePnlData.voyageParams.vesselName}</div>
        </div>

        <div className="flex flex-col gap-1">
          <div className={twMerge("text-[11px]", theme.vesselDetails.fields)}>Voyage Nr</div>
          <div className="text-[14px]">{voyagePnlData.voyageParams.voyageNumber}</div>
        </div>

        <div className="flex flex-col gap-1">
          <div className={twMerge("text-[11px]", theme.vesselDetails.fields)}>Operation type</div>
          <div
            className={twMerge(
              "flex max-w-[56px] items-center justify-center rounded-full border px-3 py-1 text-[12px]",
              theme.uwhcAssistant.text,
              theme.uwhcAssistant.chatBg,
              theme.uwhcAssistant.border,
            )}
          >
            {voyagePnlData.voyageParams.operationType}
          </div>
        </div>

        <div className="flex flex-col gap-1">
          <div className={twMerge("text-[11px]", theme.vesselDetails.fields)}>Trader</div>
          <div className="flex items-center gap-2">
            <p className="text-[14px]">
              <Avatar name={voyagePnlData.voyageParams.voyageTraderShortName ?? "NA"} />
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopPnlClarifications;
